:root {
  --travel-color-brand: #0cab83;
  --travel-color-brand-strong: #08775f;
  --travel-color-sidebar: #0e2b42;
  --travel-color-text: #172033;
  --travel-color-muted: #6f7b8c;
  --travel-color-surface: #ffffff;
  --travel-color-canvas: #f4f7fa;
  --travel-color-border: #e8edf2;
  --travel-color-warning: #f59e0b;
}
